// @ts-nocheck

import { sortBy, keyBy } from 'lodash';

import { bet as BetStateUtils } from '../../../utils';

const sortOutcomesFromTemplate = (rawOutcomes, template) => {
  let sortedOutcomes = rawOutcomes;
  if (template === 'listodd') {
    sortedOutcomes = sortBy(rawOutcomes, ['value']).filter((x) => x.value > 1);
  } else if (template === 'listalpha') {
    sortedOutcomes = sortBy(rawOutcomes, ['label']).filter((x) => x.value > 1);
  } else if (template === 'score' || template === 'setscore') {
    sortedOutcomes = sortBy(rawOutcomes, [
      ({ code }) => {
        const values = (code && code.split(':')) || [];
        if (values[0] > values[1]) return values[0] + 1;
        else if (values[0] === values[1]) return (values[0] + 1) * 1000;
        else if (values[0] < values[1]) return (values[1] + 1) * 1000000;
      },
    ]).filter((x) => x.value > 1);
  } else {
    const outcomeByCodes = BetStateUtils.betOddOrderByTemplate[template] ? keyBy(rawOutcomes, 'code') : rawOutcomes;
    const outcomeCodePossibleOrders = BetStateUtils.betOddOrderByTemplate[template] || [Object.keys(rawOutcomes)];
    const outcomeCodeSequenceToFind = BetStateUtils.betOddOrderByTemplate[template]
      ? rawOutcomes.map((x) => x.code)
      : Object.keys(rawOutcomes);
    const outcomeCodeOrder = outcomeCodePossibleOrders.reduce((finalOrder, possibleOrder) => {
      const hasBeenFound = outcomeCodeSequenceToFind.reduce(
        (found, code) => found && possibleOrder.indexOf(code) !== -1,
        true,
      );
      if (hasBeenFound && finalOrder === null) {
        return possibleOrder;
      }
      return finalOrder;
    }, null);

    sortedOutcomes = (outcomeCodeOrder || outcomeCodeSequenceToFind)
      .filter((k) => !!k)
      .map((code) => outcomeByCodes[code])
      .filter((k) => !!k);
  }

  return sortedOutcomes;
};

export default sortOutcomesFromTemplate;
